/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Bottom_Center_LabelInputs */

const en_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom Center`)
};

const fr_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas centre`)
};

const de_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte unten`)
};

const it_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In basso al centro`)
};

const ru_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижний центр`)
};

const es_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro inferior`)
};

const zh_cn2_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`底部中心`)
};

const ja_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下中央`)
};

const hi_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निचला बीच का`)
};

const pt_pt2_style_guide_manager_position_bottom_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Bottom_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro inferior`)
};

/**
* | output |
* | --- |
* | "Bottom Center" |
*
* @param {Style_Guide_Manager_Position_Bottom_Center_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_bottom_center_label = /** @type {((inputs?: Style_Guide_Manager_Position_Bottom_Center_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Bottom_Center_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_position_bottom_center_label(inputs)
	if (locale === "de") return de_style_guide_manager_position_bottom_center_label(inputs)
	if (locale === "it") return it_style_guide_manager_position_bottom_center_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_position_bottom_center_label(inputs)
	if (locale === "es") return es_style_guide_manager_position_bottom_center_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_position_bottom_center_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_position_bottom_center_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_position_bottom_center_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_position_bottom_center_label(inputs)
	return en_style_guide_manager_position_bottom_center_label(inputs)
});